// Tipos e utilitários do painel "Conta Google Ads" (relatórios da Google Ads API).

export interface GoogleMetricRow {
  impressions: number;
  clicks: number;
  cost: number;
  conversions: number;
  all_conversions: number;
  average_cpc: number;
  cost_per_conversion: number;
}

export interface GoogleAccountSummary extends GoogleMetricRow {
  id: string;
  name: string;
  currency: string;
}

export interface GoogleReportCampaign extends GoogleMetricRow {
  id: string;
  name: string;
  status: string;
  channel: string;
}

export interface GoogleAccountReport {
  account: GoogleAccountSummary | null;
  campaigns: GoogleReportCampaign[];
}

export interface GoogleBiddingRow extends GoogleMetricRow {
  kind: 'portfolio' | 'standard';
  id?: string;
  name: string;
  type: string;
  status: string;
  campaigns?: number;
}

export interface GoogleCallout {
  resource_name: string;
  status: string;
  asset_id: string;
  text: string;
}

export const num = (v: any): number => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/** Mensagem do backend (ou da quota 429) de forma legível. */
export const errorMessage = (err: any, fallback: string): string => {
  const status = err?.response?.status;
  const data = err?.response?.data;
  const msg = data?.message || data?.error || (typeof data === 'string' ? data : '') || err?.message;
  if (status === 429) {
    return msg && typeof msg === 'string'
      ? msg
      : 'A cota da API do Google Ads foi atingida. Tente novamente em alguns minutos.';
  }
  return (typeof msg === 'string' && msg) || fallback;
};
